<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="">
  <nav class="d-flex d-lg-none navbar navbar-light bg-light justify-content-between pl-1 pr-1">
    <!-- <a class="navbar-brand font-size-1" >{{ selectedCount }} Item(s)</a> -->
    <a class="navbar-brand font-size-1"> Total ({{ selectedCount }}): {{ totalPrice | currency }}</a>
    <form class="form-inline">
      <div class="d-flex justify-content-between">
        <button type="button" class="btn btn-xs btn-secondary transition-3d-hover mr-2" (click)="cancel()">Cancel</button>
        <button type="button" *ngIf="selectedBooths && selectedBooths.length > 0" class="btn btn-xs btn-primary transition-3d-hover" (click)="addToCart()">Add To Cart</button>
      </div>
    </form>
  </nav>

  <div class="row">
    <div class="col-lg-9" style="overflow: hidden">
      <div id="boundingBox" style="background-color: darkblue">
        <div #mapBox (mousewheel)="mouseWheel($any($event))" (cdkDragStarted)="dragStarted($event)" (cdkDragMoved)="dragStarted($event)" cdkDrag id="mapBox" [style.width]="map.mapWidth + 'px'" [style.height]="map.mapHeight + 'px'" style="position: relative; transform: translate3d({{ ((map.mapWidth * 0.3) / 2) * -1 }}px, {{ ((map.mapHeight * 0.3) / 2) * -1 }}px, 0px) scale(0.7); background: url('fetchImage?filename={{ map.mapAsset }}')">
          <ng-container *ngFor="let booth of map.booths">
            <a href="javascript:void(0)" (click)="selectBooth(booth)" [ngClass]="{ 'booth-selected': booth.selected, 'booth-booked': booth.booked && !booth.selected }" [style.top]="booth.mapTop + 'px'" [style.left]="booth.mapLeft + 'px'" [style.background-color]="booth.color" [style.width]="'calc(' + booth.computedWidth * 100 + '%)'" [style.height]="'calc(' + booth.computedHeight * 100 + '%)'" [style.transform]="'rotate('+booth.rotationAngle +'deg)'" id="a1562605594361" class="element booth open type50714" style="z-index: -9377"
              ><div class="bLabel d-flex align-items-center justify-content-center h-100" style="">
                <span class="blt" style="font-size: 16px; text-align: center">{{ booth.name }}</span>
              </div>
            </a>
            <div class="tooltip-div p-1 font-size-1" [style.top]="booth.mapTop + 'px'" [style.left]="'calc(' + (booth.mapLeft + 10) + 'px + ' + booth.computedWidth * 100 + '%)'" style="display: none; position: absolute; z-index: 99999; width: 200px; background-color: #464646; border: 1px solid #464646; border-radius: 3px">
              <div class="text-white" style="border-bottom: 1px solid white">Booth {{ booth.name }} - {{ booth.productName }}</div>
              <div class="text-white">Dimensions: {{ booth.heightInFeet }} x {{ booth.widthInFeet }}</div>
              <div *ngIf="!booth.booked" class="text-white">{{ booth.price | currency }}</div>
              <div *ngIf="booth.booked" class="text-white">Unavailable</div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="col-lg-3 d-none d-md-block">
      <div class="">
        <!-- Order Summary -->
        <div class="border shadow-soft rounded p-5 mb-4">
          <!-- Title -->
          <div class="border-bottom pb-4 mb-4">
            <h2 class="h5 mb-0">Booth Reservation</h2>
          </div>
          <!-- End Title -->

          <div class="border-bottom pb-4 mb-4">
            <div class="media align-items-center mb-3">
              <h3 class="text-secondary font-size-1 font-weight-normal mb-0 mr-3">Item Total ({{ selectedCount }})</h3>
              <div class="media-body text-right">
                <span class="font-weight-medium">{{ totalPrice | currency }}</span>
              </div>
            </div>

            <div class="media align-items-center mb-3">
              <h4 class="text-secondary font-size-1 font-weight-bold mb-0 mr-3">Booths</h4>
              <!-- <div class="media-body text-right">
                <span class="font-weight-medium">Free</span>
              </div> -->
            </div>

            <!-- Checkbox -->
            <div *ngFor="let booth of selectedBooths" class="card border-0 mb-3">
              <div class="card-body p-0">
                <div class="small">
                  <span class="d-block font-size-1 font-weight-medium mb-1">{{ booth.price | currency }} - Booth {{ booth.name }}</span>
                  <span class="d-block text-muted">{{ booth.productName }} {{ booth.widthInFeet }} x {{ booth.heightInFeet }}</span>
                </div>
              </div>
            </div>
            <!-- End Checkbox -->
          </div>

          <div class="media align-items-center mb-4">
            <h4 class="text-secondary font-size-1 font-weight-normal mb-0 mr-3">Total</h4>
            <div class="media-body text-right">
              <span class="font-weight-medium">{{ totalPrice | currency }}</span>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between pr-3">
          <button type="button" class="btn btn-secondary transition-3d-hover" (click)="cancel()">Close</button>
          <button type="button" *ngIf="selectedBooths && selectedBooths.length > 0 && !readOnly && !admin" class="btn btn-primary transition-3d-hover" (click)="addToCart()">Add To Cart</button>
          <button type="button" *ngIf="admin" class="btn btn-primary transition-3d-hover" (click)="update()">Update Assignment</button>
        </div>
        <!-- End Order Summary -->
      </div>
    </div>
  </div>
</div>
